import { useRef, useState } from 'react';
import { ReportingContainerBaseConfig } from '../../../../../base';
import { BooleanElementController } from './booleanElementInterface';
import { BooleanElementContainerProps } from './booleanElementProps';

export function createBooleanElementContainer(
    config: ReportingContainerBaseConfig,
    controller: BooleanElementController
): React.FC<BooleanElementContainerProps> {
    return ({ as: View, ...containerProps }) => {
        const props = controller.useProps({
            value: containerProps.value,
            onChange: containerProps.onChange,
        });
        return <View {...props} />;
    };
}
